package dev.lingvo.shared.ops

import kotlin.jvm.JvmInline
import kotlinx.serialization.Serializable

/** Text a customer typed, rendered as text and never as a control. */
@Serializable
@JvmInline
value class Untrusted(val text: String)
